module.exports = __webpack_public_path__ + "img/code8.559cd536.png";